import request from '../../utils/request'
import store from '@/store'
import { judgePermissions } from '@/utils/common.js'
import { resolve } from 'core-js/fn/promise'

const state = {
    confirmPreview: false,
    isBack: false,
    examId: null,
    tableData:[],
    confirmPaperData: {
        id: null,
        title: '',
    }
}

const actions = {
    // 获取排考管理列表
    getArrangeExamList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:examinee:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/examinee`,
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })       
                } 
            })
        })        
    },

    // 批量/删除排考
    deleteArrangeExam({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/examinee/${data.examId}`,
                method: "delete",
                params: {ids:data.ids}
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 考试计划
    getExamPlan({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:plan']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/plan`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 报考证书
    getExamCertificate({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:certificate']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/certificate`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 证书等级
    getExamCertificateGrade({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:certificateGrade']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/certificate_grade`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 报考科目
    getExamSubject({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:subject']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/subject`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 排考状态
    getExamStatus({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:status']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/status`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 试卷配置列表
    getExamPaperList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam`,
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 获取试卷下拉列表
    getArrangementExamPaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/exam/paper`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取评分规则
    getArrangementGradingRule({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/gradingRule`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取确认考试试卷
    getConfirmExamPaper({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/com.tipdm:tipdm-race-web:jar:v1.6.6/exam/certainty`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 确认考试试卷
    postConfirmExamPaper({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/com.tipdm:tipdm-race-web:jar:v1.6.6/exam/certainty`,
                method: 'post',
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 配置试卷
    putExamPaper({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:update']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam`,
                        method: "put",
                        data: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 获取考试成绩显示设置
    getExamDisplaySetting({dispatch}, id){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:displaySetting:get']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/com.tipdm:tipdm-race-web:jar:v1.6.6/score_display`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 设置考试成绩显示
    setExamDisplaySetting({dispatch}, data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:exam:displaySetting:set']).then(res => {
                if (res) {
                    request({
                        url: `/api/arrangement/exam/${data.id}/score_display`,
                        method: 'put',
                        data: data.data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },
}

export default {
    state,
    actions
}